var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Sticky_instances, _Sticky_element, _Sticky_options, _Sticky_isSticky, _Sticky_lastScroll, _Sticky_isLocked, _Sticky_scrollListener, _Sticky_trackScrollMovement, _Sticky_setSticky, _Sticky_unsetSticky, _Sticky_getFixed;
import Emitter from '@resources/js/helpers/Emitter';
import { findHtmlElement } from '@resources/js/helpers/dom';
export const STICKY_EVENTS = {
    SCROLL_DOWN: 'scroll-down',
    SCROLL_UP: 'scroll-up',
    SET_STICKY: 'set-sticky',
    UNSET_STICKY: 'unset-sticky',
};
class Sticky extends Emitter {
    constructor(selectorOrElement, options = {}) {
        super();
        _Sticky_instances.add(this);
        _Sticky_element.set(this, void 0);
        _Sticky_options.set(this, void 0);
        _Sticky_isSticky.set(this, void 0);
        _Sticky_lastScroll.set(this, void 0);
        _Sticky_isLocked.set(this, void 0);
        __classPrivateFieldSet(this, _Sticky_element, findHtmlElement(selectorOrElement), "f");
        if (!__classPrivateFieldGet(this, _Sticky_element, "f"))
            throw new Error('Sticky: element not found');
        __classPrivateFieldSet(this, _Sticky_options, Object.assign({ top: 0, bottom: 0, toggleClass: 'is-fixed', callOnInit: false, lockedClass: 'locked' }, options), "f");
        __classPrivateFieldSet(this, _Sticky_isSticky, false, "f");
        __classPrivateFieldSet(this, _Sticky_lastScroll, 0, "f");
        __classPrivateFieldSet(this, _Sticky_isLocked, false, "f");
        if (__classPrivateFieldGet(this, _Sticky_options, "f").callOnInit)
            __classPrivateFieldGet(this, _Sticky_instances, "m", _Sticky_scrollListener).call(this);
        window.addEventListener('scroll', __classPrivateFieldGet(this, _Sticky_instances, "m", _Sticky_scrollListener).bind(this), {
            passive: true,
        });
    }
    updateOptions(newOptions = {}) {
        __classPrivateFieldSet(this, _Sticky_options, Object.assign(Object.assign({}, __classPrivateFieldGet(this, _Sticky_options, "f")), newOptions), "f");
    }
    lock() {
        __classPrivateFieldSet(this, _Sticky_isLocked, true, "f");
        __classPrivateFieldGet(this, _Sticky_instances, "m", _Sticky_unsetSticky).call(this);
        __classPrivateFieldGet(this, _Sticky_element, "f").classList.add(__classPrivateFieldGet(this, _Sticky_options, "f").lockedClass);
    }
    unlock() {
        __classPrivateFieldSet(this, _Sticky_isLocked, false, "f");
        __classPrivateFieldGet(this, _Sticky_element, "f").classList.remove(__classPrivateFieldGet(this, _Sticky_options, "f").lockedClass);
        __classPrivateFieldGet(this, _Sticky_instances, "m", _Sticky_scrollListener).call(this);
    }
}
_Sticky_element = new WeakMap(), _Sticky_options = new WeakMap(), _Sticky_isSticky = new WeakMap(), _Sticky_lastScroll = new WeakMap(), _Sticky_isLocked = new WeakMap(), _Sticky_instances = new WeakSet(), _Sticky_scrollListener = function _Sticky_scrollListener() {
    if (__classPrivateFieldGet(this, _Sticky_isLocked, "f"))
        return;
    __classPrivateFieldGet(this, _Sticky_instances, "m", _Sticky_getFixed).call(this) ? __classPrivateFieldGet(this, _Sticky_instances, "m", _Sticky_setSticky).call(this) : __classPrivateFieldGet(this, _Sticky_instances, "m", _Sticky_unsetSticky).call(this);
    __classPrivateFieldGet(this, _Sticky_instances, "m", _Sticky_trackScrollMovement).call(this);
}, _Sticky_trackScrollMovement = function _Sticky_trackScrollMovement() {
    const currentScroll = window.pageYOffset;
    const isScrollGoingDown = currentScroll > __classPrivateFieldGet(this, _Sticky_lastScroll, "f");
    __classPrivateFieldSet(this, _Sticky_lastScroll, currentScroll, "f");
    if (!__classPrivateFieldGet(this, _Sticky_isSticky, "f"))
        return;
    isScrollGoingDown
        ? this.emit(STICKY_EVENTS.SCROLL_DOWN)
        : this.emit(STICKY_EVENTS.SCROLL_UP);
}, _Sticky_setSticky = function _Sticky_setSticky() {
    if (__classPrivateFieldGet(this, _Sticky_isSticky, "f"))
        return;
    __classPrivateFieldSet(this, _Sticky_isSticky, true, "f");
    __classPrivateFieldGet(this, _Sticky_element, "f").classList.add(__classPrivateFieldGet(this, _Sticky_options, "f").toggleClass);
    this.emit(STICKY_EVENTS.SET_STICKY);
}, _Sticky_unsetSticky = function _Sticky_unsetSticky() {
    if (!__classPrivateFieldGet(this, _Sticky_isSticky, "f"))
        return;
    __classPrivateFieldSet(this, _Sticky_isSticky, false, "f");
    __classPrivateFieldGet(this, _Sticky_element, "f").classList.remove(__classPrivateFieldGet(this, _Sticky_options, "f").toggleClass);
    this.emit(STICKY_EVENTS.UNSET_STICKY);
}, _Sticky_getFixed = function _Sticky_getFixed() {
    const scrollTop = document.documentElement.scrollTop || 0;
    const { top, bottom } = __classPrivateFieldGet(this, _Sticky_options, "f");
    if (bottom)
        return scrollTop > top && scrollTop < bottom;
    return scrollTop > top;
};
export default Sticky;
